export default __webpack_public_path__ + "static/media/old_logo.96fdd4e7.jpeg";